/**
 * Iniciais pro avatar: 1ª letra do primeiro + último nome, maiúsculas.
 * Retorna '' quando não há nome — o caller decide o fallback ('#', '?', ícone).
 * Array.from pega o code point inteiro (emoji/surrogate pair não quebra).
 */
export function getInitials(name: string | null | undefined): string {
  const parts = (name ?? '').trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return ''
  const first = Array.from(parts[0])[0] ?? ''
  const last = parts.length > 1 ? Array.from(parts[parts.length - 1])[0] ?? '' : ''
  return (first + last).toUpperCase()
}
